import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";

const List = () => {
  const location = useLocation();
  const [receiveData, setReceiveData] = useState([]);
  const [alert, setAlert] = useState(null);
  // const month = date.getMonth() + 1;
  // const year = date.getFullYear();
  const date = new Date();

  // Get first day of current month
  const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1)
    .toLocaleDateString('en-CA'); // This gives YYYY-MM-DD format

  // Get last day of current month  
  const lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    .toISOString()
    .split('T')[0];
  const [inputs, setInputs] = useState({
    status: "active",
    tuesday_only: "0",
    start_date: firstDayOfMonth,
    end_date: lastDayOfMonth
  });
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);

    try {
      let url = `/transaction?type=overtime`;

      // Add date range filters if provided
      if (inputs.start_date) {
        url += `&start_date=${inputs.start_date}`;
      }
      if (inputs.end_date) {
        url += `&end_date=${inputs.end_date}`;
      }

      // Add Tuesday filter if enabled
      if (inputs.tuesday_only == "0") {
        url += `&tuesday_only=0`;
      }

      const res = await Http.get(url);
      setReceiveData(res.data);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  // Refetch data when inputs change
  useEffect(() => {
    fetchData();
  }, [inputs.month, inputs.year]);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);

  const deleteData = (id, deleteApiUrl, showMsg) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Http.delete("/" + deleteApiUrl + "/" + id + "/ovetime").then((res) => {
          setReceiveData(res.data);
          Swal.fire("Deleted!", showMsg + " has been deleted.", "success");
        });
      }
    });
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const formSubmit = () => {
    let url = `/transaction?type=overtime`;
    if (inputs.start_date) {
      url += `&start_date=${inputs.start_date}`;
    }
    if (inputs.end_date) {
      url += `&end_date=${inputs.end_date}`;
    }

    // Add Tuesday filter if enabled
    if (inputs.tuesday_only === "0") {
      url += `&tuesday_only=0`;
    }

    Http.get(url).then((res) => {
      setReceiveData(res.data);
    });
  };

  // Updated function to format datetime to readable format with AM/PM
  // const formatDateTime = (dateTimeString) => {
  //   if (!dateTimeString) return "";

  //   try {
  //     // Handle ISO string format (like '2025-08-10T04:59:00.000000Z')
  //     const date = new Date(dateTimeString);

  //     // Check if date is valid
  //     if (isNaN(date.getTime())) {
  //       return dateTimeString; // Return original if invalid
  //     }

  //     // Using toLocaleString for automatic formatting
  //     return date.toLocaleString("en-US", {
  //       year: "numeric",
  //       month: "short",
  //       day: "2-digit",
  //       hour: "2-digit",
  //       minute: "2-digit",
  //       hour12: true,
  //     });
  //   } catch (error) {
  //     console.error("Date formatting error:", error);
  //     return dateTimeString; // Return original if formatting fails
  //   }
  // };

  const cols = [
    { field: "date", header: "Date" },
    { field: "staff.name", header: "Name" },
    { field: "rate", header: "Rate" },
    { field: "total_hours", header: "Hours" },
    { field: "total_amount", header: "Total Amount" },
    // {
    //   field: "is_tuesday",
    //   header: "Tuesday OT",
    //   body: (rowData) => (
    //     <span
    //       className={`badge ${
    //         rowData.is_tuesday === 1 ? "badge-success" : "badge-secondary"
    //       }`}
    //     >
    //       {rowData.is_tuesday === 1 ? "Yes" : "No"}
    //     </span>
    //   ),
    // },
    { field: "remarks", header: "Remarks" },
    {
      field: "created_at", // keep field so data is passed in
      header: "Created At",
      body: (rowData) => {
        return formatDateTime(rowData.created_at);
      },
    },
  ];

  const formatDateTime = (dateTimeString) => {
    if (!dateTimeString) return "";

    try {
      const date = new Date(dateTimeString);

      if (isNaN(date.getTime())) return dateTimeString;

      return date.toLocaleString("en-US", {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "numeric",
        minute: "2-digit",
        hour12: true, // Force AM/PM format
      });
    } catch {
      return dateTimeString;
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputs((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">Overtime</h5>
            <Link to="/create-other-overtime" className="btn btn-primary">
              <i className="fa fa-plus-square mg-r-6"></i>Overtime
            </Link>
          </div>
          <div className="am-pagebody">
            <Alert alert={alert} />

            <div className="card pd-sm-40">
              {/* <div className="row">
                <div className="col-lg">
                  <select
                    className="form-control"
                    name="year"
                    value={inputs.year}
                    onChange={handleChange}
                  >
                    <option value="">Select Year</option>
                    {[2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030].map(
                      (yearOption) => (
                        <option key={yearOption} value={yearOption}>
                          {yearOption}
                        </option>
                      )
                    )}
                  </select>
                </div>
                <div className="col-lg">
                  <select
                    className="form-control"
                    name="month"
                    value={inputs.month}
                    onChange={handleChange}
                  >
                    {[
                      { value: "01", label: "January" },
                      { value: "02", label: "February" },
                      { value: "03", label: "March" },
                      { value: "04", label: "April" },
                      { value: "05", label: "May" },
                      { value: "06", label: "June" },
                      { value: "07", label: "July" },
                      { value: "08", label: "August" },
                      { value: "09", label: "September" },
                      { value: "10", label: "October" },
                      { value: "11", label: "November" },
                      { value: "12", label: "December" },
                    ].map((monthOption, index) => (
                      <option
                        key={monthOption.value}
                        value={monthOption.value}
                        selected={
                          inputs.month === monthOption.value ||
                          inputs.month === index + 1
                        }
                      >
                        {monthOption.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-lg">
                  <button
                    className="btn btn-primary btn-block mg-b-10"
                    onClick={formSubmit}
                  >
                    <i className="fa fa-send mg-r-10"></i> Search
                  </button>
                </div>
              </div> */}
              <div className="row g-3">
                <div className="col-lg">
                  <div className="form-group">
                    <label>Start Date</label>
                    <input
                      type="date"
                      className="form-control"
                      name="start_date"
                      value={inputs.start_date}
                      onChange={handleInputChange}
                      max={inputs.end_date}
                    />
                  </div>
                </div>

                <div className="col-lg">
                  <div className="form-group">
                    <label>End Date</label>
                    <input
                      type="date"
                      className="form-control"
                      name="end_date"
                      value={inputs.end_date}
                      onChange={handleInputChange}
                      min={inputs.start_date}
                    />
                  </div>
                </div>

                <div className="col-lg-2 d-flex align-items-center">
                  <button
                    className="btn btn-primary w-100 mt-2"
                    onClick={formSubmit}
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <i className="fa fa-spinner fa-spin me-2" /> Loading...
                      </>
                    ) : (
                      <>
                        <i className="fa fa-refresh me-2" /> Submit
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="am-pagebody">
            <div className="card pd-20 pd-sm-40">
              <ReactDataTable
                cols={cols}
                receiveData={receiveData}
                isLoading={loading}
                actionTemplate={actionTemplate}
                deleteData={deleteData}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const actionTemplate = (item, deleteData) => {
  return (
    <td className="text-xs">
      {/* <Link
        to={{ pathname: "/edit-other-overtime/" + item.id }}
        className="btn btn-primary btn-sm"
      >
        <i className="fa fa-pencil" aria-hidden="true"></i>
      </Link> */}
      <button
        className="btn btn-danger btn-sm ms-1"
        onClick={() => deleteData(item.id, "transaction", "Overtime")}
      >
        <i className="fa fa-trash"></i>
      </button>
    </td>
  );
};

export default List;
